import {
  HelenaDocumentType,
  HelenaPatientStatusEnum,
  HelenaPrescriptionType,
  HelenaSessionKey,
} from "model/helena.model";
import { HelenaRegistration } from "model/helena-registration.model";

/** ---- Dispatch Types ---- */

export const CHECK_HELENA_ENABLED_START = "CHECK_HELENA_ENABLED_START";
export const CHECK_HELENA_ENABLED_SUCCESS = "CHECK_HELENA_ENABLED_SUCCESS";
export const CHECK_HELENA_ENABLED_ERROR = "CHECK_HELENA_ENABLED_ERROR";
export const ENABLE_HELENA_START = "ENABLE_HELENA_START";
export const ENABLE_HELENA_SUCCESS = "ENABLE_HELENA_SUCCESS";
export const ENABLE_HELENA_ERROR = "ENABLE_HELENA_ERROR";
export const SESSION_HELENA_START = "SESSION_HELENA_START";
export const SESSION_HELENA_SUCCESS = "SESSION_HELENA_SUCCESS";
export const SESSION_HELENA_ERROR = "SESSION_HELENA_ERROR";
export const PATIENT_ID_HELENA_START = "PATIENT_ID_HELENA_START";
export const PATIENT_ID_HELENA_SUCCESS = "PATIENT_ID_HELENA_SUCCESS";
export const PATIENT_ID_HELENA_ERROR = "PATIENT_ID_HELENA_ERROR";
export const PATIENT_STATUS_HELENA_START = "PATIENT_STATUS_HELENA_START";
export const PATIENT_STATUS_HELENA_SUCCESS = "PATIENT_STATUS_HELENA_SUCCESS";
export const PATIENT_STATUS_HELENA_ERROR = "PATIENT_STATUS_HELENA_ERROR";
export const REGISTRATION_LINK_HELENA_START = "REGISTRATION_LINK_HELENA_START";
export const REGISTRATION_LINK_HELENA_SUCCESS =
  "REGISTRATION_LINK_HELENA_SUCCESS";
export const REGISTRATION_LINK_HELENA_ERROR = "REGISTRATION_LINK_HELENA_ERROR";
export const REGISTRATION_FINISHED_HELENA_START =
  "REGISTRATION_FINISHED_HELENA_START";
export const REGISTRATION_FINISHED_HELENA_SUCCESS =
  "REGISTRATION_FINISHED_HELENA_SUCCESS";
export const REGISTRATION_FINISHED_HELENA_ERROR =
  "REGISTRATION_FINISHED_HELENA_ERROR";
export const PRESCRIPTIONS_HELENA_START = "PRESCRIPTIONS_HELENA_START";
export const PRESCRIPTIONS_HELENA = "PRESCRIPTIONS_HELENA";
export const ATTESTATION_HELENA_START = "ATTESTATION_HELENA_START";
export const ATTESTATION_HELENA = "ATTESTATION_HELENA";
export const ATTESTATION_HELENA_ERROR = "ATTESTATION_HELENA_ERROR";

/** ---- Dispatch Interfaces ---- */
interface AttestationHelenaStart {
  type: typeof ATTESTATION_HELENA_START;
  payload: HelenaDocumentType;
}

interface AttestationHelenaError {
  type: typeof ATTESTATION_HELENA_ERROR;
  payload: any;
}

interface AttestationHelena {
  type: typeof ATTESTATION_HELENA;
  payload: HelenaDocumentType;
}

interface CheckHelenaEnabledStartAction {
  type: typeof CHECK_HELENA_ENABLED_START;
}

interface CheckHelenaEnabledSuccessAction {
  type: typeof CHECK_HELENA_ENABLED_SUCCESS;
  payload: boolean;
}

interface CheckHelenaEnabledErrorAction {
  type: typeof CHECK_HELENA_ENABLED_ERROR;
}

interface EnableHelenaStartAction {
  type: typeof ENABLE_HELENA_START;
}

interface EnableHelenaSuccessAction {
  type: typeof ENABLE_HELENA_SUCCESS;
}

interface EnableHelenaErrorAction {
  type: typeof ENABLE_HELENA_ERROR;
}

interface SessionHelenaStartAction {
  type: typeof SESSION_HELENA_START;
}

interface SessionHelenaSuccessAction {
  type: typeof SESSION_HELENA_SUCCESS;
  payload: HelenaSessionKey;
}

interface SessionHelenaErrorAction {
  type: typeof SESSION_HELENA_ERROR;
}

interface PatientIdHelenaStartAction {
  type: typeof PATIENT_ID_HELENA_START;
}

interface PatientIdHelenaSuccessAction {
  type: typeof PATIENT_ID_HELENA_SUCCESS;
  payload: string;
}

interface PatientIdHelenaErrorAction {
  type: typeof PATIENT_ID_HELENA_ERROR;
  payload: any;
}

interface PatientStatusHelenaStartAction {
  type: typeof PATIENT_STATUS_HELENA_START;
}

interface PatientStatusHelenaSuccessAction {
  type: typeof PATIENT_STATUS_HELENA_SUCCESS;
  payload: HelenaPatientStatusEnum;
}

interface PatientStatusHelenaErrorAction {
  type: typeof PATIENT_STATUS_HELENA_ERROR;
  payload: any;
}

interface RegistrationLinkHelenaStartAction {
  type: typeof REGISTRATION_LINK_HELENA_START;
}

interface RegistrationLinkHelenaSuccessAction {
  type: typeof REGISTRATION_LINK_HELENA_SUCCESS;
  payload: string;
}

interface RegistrationLinkHelenaErrorAction {
  type: typeof REGISTRATION_LINK_HELENA_ERROR;
}

interface RegistrationFinishedHelenaStartAction {
  type: typeof REGISTRATION_FINISHED_HELENA_START;
}

interface RegistrationFinishedHelenaSuccessAction {
  type: typeof REGISTRATION_FINISHED_HELENA_SUCCESS;
  payload: HelenaRegistration;
}

interface RegistrationFinishedHelenaErrorAction {
  type: typeof REGISTRATION_FINISHED_HELENA_ERROR;
}

interface PrescriptionHelenaStart {
  type: typeof PRESCRIPTIONS_HELENA_START;
  payload: Array<HelenaPrescriptionType>;
}

interface PrescriptionsHelenaSuccess {
  type: typeof PRESCRIPTIONS_HELENA;
}

export type EnableHelenaType = (userId: number) => void;
export type DisableHelenaActivationQuestionType = (userId: number) => void;

export type RegistrationFinishedType = (
  userId: number,
  sessionKey: HelenaSessionKey,
  inss: string
) => Promise<string | undefined>;

export type HelenaAction =
  | AttestationHelena
  | AttestationHelenaStart
  | AttestationHelenaError
  | PrescriptionHelenaStart
  | PrescriptionsHelenaSuccess
  | CheckHelenaEnabledStartAction
  | CheckHelenaEnabledSuccessAction
  | CheckHelenaEnabledErrorAction
  | EnableHelenaStartAction
  | EnableHelenaSuccessAction
  | EnableHelenaErrorAction
  | SessionHelenaStartAction
  | SessionHelenaSuccessAction
  | SessionHelenaErrorAction
  | PatientIdHelenaStartAction
  | PatientIdHelenaSuccessAction
  | PatientIdHelenaErrorAction
  | PatientStatusHelenaStartAction
  | PatientStatusHelenaSuccessAction
  | PatientStatusHelenaErrorAction
  | RegistrationLinkHelenaStartAction
  | RegistrationLinkHelenaSuccessAction
  | RegistrationLinkHelenaErrorAction
  | RegistrationFinishedHelenaStartAction
  | RegistrationFinishedHelenaSuccessAction
  | RegistrationFinishedHelenaErrorAction;
